import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../../i18n'; // adjust path to match your project's i18n import
import '../../../../../styles/components/iso-certification-section.scss';

const STANDARDS = [
    {
        code: 'ISO 9001:2015',
        nameKey: 'iso_standard_9001_name',
        statusKey: 'iso_standard_9001_status',
        image: '/assets/certificates/iso-9001-2015.png',
    },
    {
        code: 'ISO 14001:2015',
        nameKey: 'iso_standard_14001_name',
        statusKey: 'iso_standard_14001_status',
        image: '/assets/certificates/iso-14001-2015.png',
    },
    {
        code: 'ISO 45001:2018',
        nameKey: 'iso_standard_45001_name',
        statusKey: 'iso_standard_45001_status',
        image: '/assets/certificates/iso-45001-2018.png',
    },
    {
        code: 'ISO 29001:2020',
        nameKey: 'iso_standard_29001_name',
        statusKey: 'iso_standard_29001_status',
        image: '/assets/certificates/iso-29001-2020.png',
    },
];

const ACCREDITED_BY = ['UAF', 'IAF MLA', 'ARS'];

class IsoCertificationSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
        };
        this.handleSelect = this.handleSelect.bind(this);
        this.handleOpenFullSize = this.handleOpenFullSize.bind(this);
    }

    handleSelect(index) {
        if (index === this.state.activeIndex) return;
        this.setState({ activeIndex: index });
    }

    handleOpenFullSize() {
        const active = STANDARDS[this.state.activeIndex];
        if (!active) return;

        if (typeof this.props.onOpenFullSize === 'function') {
            this.props.onOpenFullSize(active);
            return;
        }
        window.open(active.image, '_blank', 'noopener,noreferrer');
    }

    render() {
        const { activeIndex } = this.state;
        const isRtl = i18n.language === 'ar';
        const active = STANDARDS[activeIndex] || STANDARDS[0];

        return (
            <section className={'iso-cert' + (isRtl ? ' iso-cert--rtl' : '')} dir={isRtl ? 'rtl' : 'ltr'}>
                <div className="iso-cert__container">

                    <div className="iso-cert__info">
                        <div className="iso-cert__eyebrow">
                            <span className="iso-cert__eyebrow-line" />
                            <span>{i18n.t('iso_eyebrow')}</span>
                        </div>

                        <h2 className="iso-cert__title">
                            {i18n.t('iso_title_line1')}
                            <br />
                            {i18n.t('iso_title_line2')}
                        </h2>
                        <p className="iso-cert__description">{i18n.t('iso_description')}</p>

                        <ul className="iso-cert__list" role="list">
                            {STANDARDS.map((standard, index) => {
                                const isActive = index === activeIndex;
                                return (
                                    <li key={standard.code}>
                                        <button
                                            type="button"
                                            className={
                                                'iso-cert__item' +
                                                (isActive ? ' iso-cert__item--active' : '')
                                            }
                                            onClick={() => this.handleSelect(index)}
                                            aria-pressed={isActive}
                                        >
                                            <span className="iso-cert__badge">
                                                {String(index + 1).padStart(2, '0')}
                                            </span>
                                            <span className="iso-cert__item-text">
                                                <span className="iso-cert__item-code">{standard.code}</span>
                                                <span className="iso-cert__item-name">{i18n.t(standard.nameKey)}</span>
                                            </span>
                                            <span className="iso-cert__status">{i18n.t(standard.statusKey)}</span>
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>

                        <div className="iso-cert__accredited">
                            <span className="iso-cert__accredited-label">{i18n.t('iso_accredited_label')}</span>
                            <div className="iso-cert__accredited-badges">
                                {ACCREDITED_BY.map((badge) => (
                                    <span className="iso-cert__accredited-badge" key={badge}>
                                        {badge}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="iso-cert__viewer">
                        <div className="iso-cert__frame">
                            <img
                                key={active.code}
                                className="iso-cert__frame-image"
                                src={active.image}
                                alt={active.code}
                            />
                        </div>
                        <button
                            type="button"
                            className="iso-cert__open-btn"
                            onClick={this.handleOpenFullSize}
                        >
                            {i18n.t('iso_open_full_size')}
                        </button>
                    </div>

                </div>
            </section>
        );
    }
}

IsoCertificationSection.propTypes = {
    onOpenFullSize: PropTypes.func,
};

IsoCertificationSection.defaultProps = {
    onOpenFullSize: null,
};

export default IsoCertificationSection;